import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { homeapple, homechoose, homecomming, homeconnect, homeCONTACTLESS, homegoogle, homeHYGIENE, homeicecrmsndwchch, homemedia1, homemobile, homeno, homeproname, homequote, homesimplefacbook, homeSLEEVED, homeweare1, homeweare2, homeweareimg } from '../../MediaConstants/Index';
import { GetSiteSettingsApi } from '../../Redux/Auth/Auth_Action';
import AboutUsSec from './AboutUsSec';
import HomeBannerContent1 from './HomeBannerContent1';
import HomeBannerContent2 from './HomeBannerContent2';
import TestimonialItems from './TestimonialItems';
import TopSliderHome from './TopSliderHome';
import TruckCleanessHome from './TruckCleanessHome';
// import { FacebookProvider, EmbeddedPost } from 'react-facebook';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const HomeContent = () => {
    const navigate = useNavigate();
    const [changeHomeBanner, setChangeHomeBanner] = useState(1);
    const FunctionChangeBanner = (e) => {
        setChangeHomeBanner(e);
    }

    const [siteData, setSiteData] = useState(null);
    const dispatch = useDispatch();
    const getSiteSetting = () => {
        dispatch(GetSiteSettingsApi())
            .then((res) => {
                setSiteData(res?.data?.response?.data[0])
            })
            .catch((e) => {
                console.log(e);
            })
    }

    useEffect(() => {
        getSiteSetting();
        window.scroll(0, 0);
    }, [])
    return (
        <div className='HomeContent'>
            {/* <!-- banner starts here --> */}
            <section className="banner">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 ">
                            <div className='home_top_slider'>
                                <TopSliderHome setChangeHomeBanner={setChangeHomeBanner} />
                            </div>
                            {/* <div className="banner-content-wrapper wow animate__animated animate__fadeInLeft">
                                <h2>Get It on the <span>fun</span></h2>
                                <h1>Mister Softee</h1>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. <br /> Lorem Ipsum has
                                    been the industry's standard dummy text ever since the <br /> 1500s,
                                </p>
                                <Link to="/about" className="btn">Learn More</Link>
                                <button
                                    onClick={() => { FunctionChangeBanner(2) }}
                                    className="btn free_topping ml-2">Get Free Topping</button>
                            </div> */}
                        </div>
                        <div className="col-lg-5">
                            {(changeHomeBanner === 1) && <HomeBannerContent1 FunctionChangeBanner={FunctionChangeBanner} />}
                            {(changeHomeBanner === 2) && <HomeBannerContent2 FunctionChangeBanner={FunctionChangeBanner} />}
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- banner ends here -->
            <!-- who we are sec starts here --> */}
            <section className="who-we-are">
                <div className="container">
                    <AboutUsSec />
                </div>
                <img src={homeweare2} className="we1" alt="" />
                <img src={homeweare1} className="we2" alt="" />
            </section>
            {/* <!-- who we are sec ends here -->
                    <!-- cleanliness starts here --> */}
            <section className="cleanliness">
                <div className="container">
                    <div className="row pb-5">
                        <div className="col-lg-12">
                            <div className="content-wrapper clen text-center wow animate__animated animate__fadeInDown">
                                <h3>Truck Cleanliness Is Our Priority</h3>
                                <h2>Here’s What We Do To Keep You Healthy</h2>
                            </div>
                        </div>
                    </div>
                    <TruckCleanessHome />
                </div>
            </section>
            {/* <!-- cleanliness ends here -->
                    <!-- connect starts here --> */}
            <section className="connect">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5 wow animate__animated animate__fadeInDown">
                            <div className="main-content-wrapper">
                                <h3>Connect With Us</h3>
                                <h2>We are Social</h2>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="content-wrapper wow animate__animated animate__fadeInLeft">
                                <h2>Follow Us On <br /> Instagram & Facebook</h2>
                                <p>Stay up to date on our innovative new concept and receive  special offers on the Mister Softee On Demand social media accounts.</p>
                                {/* <a href={`${siteData?.facebook}`}></a> */}
                                <a href={`${siteData?.facebook}`} target='_blank'>
                                    <FacebookIcon className=" cursor_pointer mr-2" />

                                </a>
                                <a href={`${siteData?.instagram}`} target='_blank'>
                                    <InstagramIcon className="cursor_pointer mr-2" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="media-wrapper">
                                <div className="row">
                                    <div className="offset-lg-2 col-lg-10 text-center">
                                        <div className="card-wrapper">
                                            {/* <div className="card-img-wrapper">
                                                <figure>
                                                    <img src={homemedia1} className="img-fluid wow animate__animated animate__pulse"
                                                        alt="" />
                                                </figure>
                                            </div>
                                            <div className="card-content-wrapper wow animate__animated animate__fadeInDown">
                                                <ul>
                                                    <li>
                                                        <img src={homeproname} alt="" />
                                                    </li>
                                                    <li>
                                                        <div className="pro-name-and-date-wrapper">
                                                            <h5>Mister Softee</h5>
                                                            <h6>@Mister Softee &nbsp; &nbsp; &nbsp; 2 days ago</h6>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <img src={homesimplefacbook} alt="" />
                                                    </li>
                                                </ul>
                                                <h6>Lorem Ipsum is simply</h6>
                                                <p>
                                                    #love #instagood #photooftheday
                                                    #fashion #beautiful #happy #cute
                                                    #tbt #followme #summer

                                                </p>
                                            </div> */}
                                            {/* <iframe className='w-100' src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fmistersofteeondemand%2Fposts%2Fpfbid0iYijPnpivY3ijE7AbXeHCLNJygWpPtang4riQp2w3Rd641j5ZE29h8ixsMXgX2nNl&show_text=true&width=500" width="500" height="674" scrolling="no" frameBorder="0" allowFullScreen="true" allow="autoPlay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe> */}
                                           
                                           {/* ifarme for facebook whole page */}
                                            <iframe className='w-100 m-auto' src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmistersofteeondemand%2F&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId" height="500" scrolling="no" frameBorder="0" allowFullScreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>

                                            {/* <iframe width="320" height="440" src="http://instagram.com/p/qbq6fIJMVZ/embed" frameborder="0"></iframe> */}

                                        </div>
                                    </div>
                                    {/* <div className="col-lg-6">
                                        <div className="card-wrapper mt-5">            
                                            <iframe className='w-100' src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fmistersofteeondemand%2Fposts%2Fpfbid025LWUwSrP42nM4JXKxfxvGAqPg3dqTXZrg47pjixz5MPM76DjaLGsa4vbeShfS7dEl&show_text=true&width=500" width="500" height="674" scrolling="no" frameBorder="0" allowFullScreen="true" allow="autoPlay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- connect ends here --> */}

            {/* <!-- comming starts here --> */}
            <section className="coming">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <figure>
                                <img src={homemobile} className="img-fluid wow animate__animated animate__tada" alt="" />
                            </figure>
                        </div>
                        <div className="col-lg-8 align-self-center">
                            <div className="content-wrapper wow animate__animated animate__fadeInRight">
                                <h4>Available Now </h4>
                                <h1>Mister Softee On Demand <span>App</span></h1>
                                <p>
                                    What can be more exciting than ordering your favorite ice cream truck via a mobile application?   </p>
                                <p>Whether you want ice cream at your wedding, birthday party, workplace, or school fundraiser, we got you covered. </p>
                                {/* <div>
                                    <button onClick={() => { navigate('/bookevent') }} className="btn mb-4">ICE CREAM AT YOUR DOOR? YES PLEASE.</button>
                                </div> */}
                                <a href="https://www.apple.com/app-store">
                                    <img src={homeapple} className="img-fluid mr-1" alt="" />
                                </a>
                                <a href="https://play.google.com/store">
                                    <img src={homegoogle} className="img-fluid" alt="" />
                                </a>
                                {/* <Link to="/bookevent">
                                    ICE CREAM AT YOUR DOOR? YES PLEASE.
                                </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
                <img src={homecomming} className="ice" alt="" />
            </section>
            {/* <!-- comming ends here --> */}

            {/* <!-- testimonails starts here --> */}
            <section className="testimonials">
                <img src={homeconnect} className="connec" alt="" />
                <div className="container">
                    <div className="row">
                        <div className='col-lg-12 text-center'>
                            <h2 className='mb-5'>Mister Softee Client Testimonials</h2>
                        </div>
                        <div className="col-lg-4">
                            <div className="content-wrapper wow animate__animated animate__fadeInDown">
                                <h3>
                                    Their Words. Our Motivation.
                                </h3>
                                {/* <h2>Here’s what our customers say about us. </h2> */}
                                <p>
                                    Here’s what our customers say about us.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="testimonails-wrapper">
                                {/* 3 time same */}

                                <TestimonialItems />
                            </div>
                            <div className="img-wrapper">
                                <img src={homeicecrmsndwchch} className="sandwish" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- testimonails ends here --> */}

        </div>
    )
}

export default HomeContent;